import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Box, Typography, Button, TextField } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import Lock from '@mui/icons-material/Lock';
import { setToken } from '../reducer/AuthSlice';
import { encryption, REST_API_BASE_URL, defaultHome, getIv, extractName, extractInitials } from '../utils/utils';
import { loadFavicon, resetFavicon } from '../utils/Favicon';

export default function LoginForm(props) {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [iv,  setIv] = useState(getIv());
  const dispatch = useDispatch();
  const token = useSelector(state => state.auth.token);

  useEffect(() => {
    const message = localStorage.getItem("errorMessage");
    console.log("Error Message is: " + message);

    if(!error && message) {
      console.log("Error message is set.");
      setErrorMsg(message);
      setError(true);
      localStorage.removeItem("errorMessage");
    } else {
      console.log("Error message is not set.");
    }
  }, []); 

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(formData.username.trim() && formData.password.trim()) {
      extractName(formData.username);
      extractInitials(formData.username);

      const user = {
        username: encryption(formData.username, iv),
        password: encryption(formData.password, iv),
        iv: iv.toString(CryptoJS.enc.Base64)
      }
      loadFavicon();

      try {
        const response = await axios.post(REST_API_BASE_URL + 'login', user, {
          headers: {
            'Content-Type': 'application/json'
          },
        });

        console.log(response.data);
      //   const accessToken = response.data['accessToken'];

      // dispatch(setToken(accessToken));
      dispatch(setToken(response.data));
      setError(false);
      } catch (error) {
        console.error("Error submitting form:", error);
        if(error.status) {
          switch(error.status) {
            case 400: 
              setErrorMsg("User does not exist.");
              break;

            case 401:
              setErrorMsg("Password is incorrect.");
              break;

            case 500:
              setErrorMsg("Server side error, please try again later or contact admin.");
              break;
          }
        }else if(error.code === "ERR_NETWORK") {
          setErrorMsg("Server side error, please try again later or contact admin.");
        }
        setError(true);
      } finally {
        resetFavicon();
        setFormData({ username: "", password: "" });
      }
    } else {
      setError(true);
    }
  };

  return (
    <>
      {token !== null ? (
        <Navigate to={defaultHome} />  
      ) : (
        <Box
          component="form"
          sx={{ '& > :not(style)': { m: 1, width: '40ch', }, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '50px'}}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          {error && <Box 
            sx={{ display: 'flex', justifyContent: 'center' }} 
          >
            <Typography 
              component={"p"} 
              variant="subtitle1" 
              color="error" 
            >
              {errorMsg}
            </Typography>
          </Box>}
          <Box 
            sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}
          >
            <PersonIcon 
              sx={{ color: 'action.active', mr: 1, my: 0.5 }} 
            />
            <TextField 
              id="username" 
              label="Username" 
              name='username' 
              type='input' 
              value={formData.username} 
              variant="standard" 
              sx={{width: '100%'}} 
              onChange={handleChange}
              helperText={error && !formData.username.trim() && "Username required"}
            />
          </Box>
          <Box 
            sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}
          >
            <Lock 
              sx={{ color: 'action.active', mr: 1, my: 0.5 }} 
            />
            <TextField 
              id="password" 
              label="Password" 
              name='password' 
              type='password' 
              value={formData.password} 
              variant="standard" 
              sx={{width: '100%'}}  
              onChange={handleChange} 
              helperText={error && !formData.password.trim() && "Password required"}
            />
          </Box>
          <Box sx={{display: 'flex', justifyContent: 'center'}}>
            <Button 
              type="submit" 
              variant="outlined" 
              color='inherit' 
              sx={{ width: '50%',color: 'white', backgroundColor: 'red', '&:hover': { backgroundColor: '#8b0000' }}}
            >
              Login
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
}
